type ICampaignQueryParams = Record<string | number, string | number>;
//filter array of objects by key name
export const filterArrayOfObjByKey = (arr: any[], passedKey: string | number) =>
    arr?.filter((item) => passedKey in item);

export const ObjectComparisonBool = <
    T extends Record<string | number, string | number>
>(
    firstObj: T,
    secondObj: T
) => {
    const firstObjectKeys = Object.keys(firstObj);
    const secondUTMSKeys = Object.keys(secondObj);

    return firstObjectKeys.every((key) => secondUTMSKeys.includes(key));
};

export const setLocalStorage = (
    localStorageName: string,
    localStorageKey: number | string,
    localStorageVal: ICampaignQueryParams | ICampaignQueryParams[]
) => {
    const localStorageObject = {
        [localStorageKey]: localStorageVal,
    };
    let localObjString = ``;

    if (typeof window !== `undefined`) {
        localObjString = JSON.stringify(localStorageObject);
        localStorage.setItem(`${localStorageName}`, localObjString);
    }
};

export const getLocalStorage = (localStorageName: string) => {
    const present = Date.now();
    let localStorageObject = null;
    let retrievedLocalStorage = null;
    if (typeof window !== `undefined`) {
        localStorageObject = localStorage.getItem(localStorageName);
    }
    if (localStorageObject) {
        retrievedLocalStorage = JSON.parse(localStorageObject);
    }

    if (
        retrievedLocalStorage &&
        Object.hasOwn(retrievedLocalStorage, `expiry`)
    ) {
        if (present > retrievedLocalStorage?.expiry) {
            localStorage.removeItem(localStorageName);
            return null;
        }
    }

    return retrievedLocalStorage || null;
};

export const updateLocalStorage = (
    localStorageName: string,
    localStorageKey: number | string,
    localStorageVal:
        | ICampaignQueryParams
        | ICampaignQueryParams[]
        | string
        | number
) => {
    let currentLocalStorageObj = null;

    if (typeof window !== `undefined`) {
        currentLocalStorageObj = JSON.parse(
            localStorage.getItem(localStorageName)
        );

        if (!currentLocalStorageObj) {
            currentLocalStorageObj = {};
        }
        currentLocalStorageObj[localStorageKey] = localStorageVal;

        localStorage.setItem(
            localStorageName,
            JSON.stringify(currentLocalStorageObj)
        );
    }
};

export const isURLValid = (urlString: string) => {
    if (typeof window !== `undefined`) {
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            console.error(e);
            return false;
        }
    }
};

export const queryBuilder = (filters: string[], isAppendingQuery?: boolean) => {
    if (typeof window === `undefined`) return;
    const campaignParams = new URLSearchParams();
    const queryAppend = isAppendingQuery ? `&` : `?`;
    let getCampaignTracking: Record<string, string> = null;
    let campaignParamsToString = ``;

    getCampaignTracking = getLocalStorage(`campaignTracking`);
    const storedUTMParams = getCampaignTracking?.latest_visit || null;

    if (storedUTMParams !== null && Object.keys(storedUTMParams).length > 0) {
        for (const [key, value] of Object.entries(storedUTMParams)) {
            if (filters && filters?.length > 0) {
                filters.some((filter) => {
                    if (key.includes(filter)) {
                        campaignParams.append(key, value);
                    }
                });
            }
        }
        campaignParamsToString = `${queryAppend}${campaignParams.toString()}`;
    }

    return campaignParamsToString;
};

export const CampaignTracking = (location, termsFilter?: string[]) => {
    if (typeof window === `undefined`) return;
    const URLParams = new URLSearchParams(location.search);
    const URLParamsExist = URLParams.size > 0;
    const existingCampaignStorage = getLocalStorage(`campaignTracking`);
    const currentCampaignSession = sessionStorage.getItem(
        `start_campaign_session`
    );

    const today: Date = new Date();
    const formatter = new Intl.DateTimeFormat(`en-US`, {
        year: `numeric`,
        month: `long`,
        day: `numeric`,
        hour: `2-digit`,
        minute: `2-digit`,
        second: `2-digit`,
    });
    const friendlyDate = formatter.format(today);

    const tempQueryParams: ICampaignQueryParams = {
        date: friendlyDate,
    };
    const campaignTerms = termsFilter || [];

    for (const [key, value] of URLParams) {
        if (campaignTerms.length > 0 && URLParamsExist) {
            for (const term of campaignTerms) {
                if (key.includes(term)) {
                    tempQueryParams[key.toLowerCase()] = value;
                }
                break;
            }
        } else {
            tempQueryParams[key.toLowerCase()] = value;
        }
    }

    if (existingCampaignStorage) {
        const updateUTMParams = Object.assign(
            existingCampaignStorage.latest_visit,
            tempQueryParams
        );
        if (currentCampaignSession) {
            if (URLParamsExist) {
                // when in the current/first visit, update existing campaignTracking storage ONLY with new UTM params - no empty parameters - handles Learn and Search
                updateLocalStorage(
                    `campaignTracking`,
                    `latest_visit`,
                    updateUTMParams
                );
            }
        } else {
            sessionStorage.setItem(`start_campaign_session`, friendlyDate);
            // when in returned visits/new sessions, campaignTracking storage can be empty or with UTM params, depending on the link clicked
            updateLocalStorage(
                `campaignTracking`,
                `latest_visit`,
                tempQueryParams
            );
        }
    } else {
        if (URLParamsExist) {
            sessionStorage.setItem(`start_campaign_session`, friendlyDate);
            localStorage.setItem(
                `campaignTracking`,
                JSON.stringify({
                    first_visit: tempQueryParams,
                    latest_visit: tempQueryParams,
                })
            );
        }
    }
};
